<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Pengaturan</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Pembayaran EDC</div>
					</div>
					<div class="col-6 col-md-3 pl-0 pr-0 pt-2 pt-md-0 mt-auto mb-auto d-flex justify-content-end">
						<button class="col-12 col-lg-10 btn btn-white d-flex justify-content-center" @click="addAdmin('add')">
							<span class="font-size-10 font-size-sm-8"><i class="fas fa-plus"></i></span>
							<div class="pl-2 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">tambah edc</div>
						</button>
					</div>
				</div>
			</div>
			<div class="col-12 pl-0 pr-0">
				<div class="row" v-show="edc.length == 0">
					<div class="col-12 pr-0 d-flex">
						<div class="col-4 pl-0 pt-3" v-for="(index) in 3" :key="index">
							<div class="col-12 pt-3 pb-3 rounded-cus cus-box-shadow bg-white">
								<vcl :width='300' :height='105'>
									<rect x="5" y="5" rx="2" ry="2" width="100" height="30" />
									<rect x="255" y="10" rx="4" ry="4" width="15" height="15" />
									<rect x="280" y="10" rx="4" ry="4" width="15" height="15" />
									<rect x="5" y="50" rx="2" ry="2" width="60" height="16" />
									<rect x="250" y="40" rx="8" ry="8" width="45" height="18" />
									<rect x="5" y="72" rx="2" ry="2" width="75" height="12" />
									<rect x="5" y="90" rx="2" ry="2" width="120" height="12" />
								</vcl>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 pt-3 pl-0 pr-0" v-if="edc == 'error'">
					<div class="col-12 pt-3 pb-4 rounded-cus cus-box-shadow bg-white d-flex flex-wrap justify-content-center">
						<div class="col-4">
							<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
						</div>
						<div class="col-12 pt-3 text-center">Belum ada EDC yang tersedia!</div>
					</div>
				</div>
				<div class="row" v-else-if="edc.length > 0">
					<div class="col-12 pr-0 d-flex flex-wrap">
						<div class="col-12 col-md-6 col-lg-4 pl-0 pt-3" v-for="(value,index) in edc" :key="index">
							<div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
								<div class="col-8 pl-2">
									<div class="col-6 pl-0 pr-0">
										<img class="img-fluid mt-n1 mt-md-n3" :src=value.stockist_edc_bank_image>
									</div>
								</div>
								<div class="col-4 pr-2">
									<div class="col-12 pl-0 pr-0 pt-2 d-flex justify-content-end">
										<div @click="delAdmin(value.stockist_edc_id)" class="mr-3 color-red cursor-pointer"><i class="fas fa-trash"></i></div>
										<div @click="edit(value, 'edit')" class="cursor-pointer"><i class="fas fa-cog"></i></div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-3 d-flex justify-content-end">
										<label class="switch">
											<input type="checkbox" :checked="value.stockist_edc_is_active==1" @input="editEDC(value)">
											<span class="slider round"></span>
										</label>
									</div>
								</div>
								<div class="col-12">
									<div class="font-weight-bold">{{value.stockist_edc_name}}</div>
									<div class="pt-1 font-size-11">{{value.stockist_edc_bank_account_name}}</div>
									<div class="pt-1 font-size-11">{{value.stockist_edc_bank_account_no}}</div>
								</div>
							</div>
						</div>
						<!-- <div class="col-4 pl-0 pt-3 edc-off">
							<div class="col-12 pt-3 pb-3 d-flex rounded-cus cus-box-shadow bg-white">
								<div class="col-8 pl-2">
									<div class="col-6 pl-0 pr-0">
										<img class="img-fluid mt-n3" src="/assets/bank/bca.svg">
									</div>
									<div class="font-weight-bold">BCA EDC</div>
									<div class="pt-1 font-size-11">Milagros 1</div>
									<div class="pt-1 font-size-11">456 505 0334</div>
								</div>
								<div class="col-4 pr-2">
									<div class="col-12 pl-0 pr-0 pt-2 d-flex justify-content-end">
										<div class="mr-3 color-red cursor-pointer"><i class="fas fa-trash"></i></div>
										<div class="cursor-pointer"><i class="fas fa-cog"></i></div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-3 d-flex justify-content-end">
										<label class="switch">
											<input type="checkbox">
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalAddAdmin" class="modal-small">
			<template v-slot:header>
				<div class="modal-header no-border p-3">
					<div v-if="action == 'add'" class="col-12 modal-title font-size-12 font-weight-bold color-blue text-uppercase text-center">
						tambah mesin edc
					</div>
					<div v-else class="col-12 modal-title font-size-12 font-weight-bold color-blue text-uppercase text-center">
						edit mesin edc
					</div>
					<button class="btn no-box-focus"><span @click="hideAddAdmin" class="close-modal ml-2 color-red"><i class="fas fa-times"></i></span></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="col-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0">
							<input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nomor / kode mesin EDC" v-model="params.stockist_edc_no" @click="getNomorEdc" @focus="() => konfirmResponse.edc_no = ''">
							<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.edc_no">{{konfirmResponse.edc_no}}</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3">
							<input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nama mesin EDC" v-model="params.stockist_edc_name" @click="getNamaEdc" @focus="() => konfirmResponse.edc_name = ''">
							<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.edc_name">{{konfirmResponse.edc_name}}</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3">
							<v-select label="edc_bank_name" class="font-size-11" placeholder="Pilihan Bank EDC" v-model="params.stockist_edc_bank_name" :options="bank" @click="getBankName" :reduce="bank => bank.edc_bank_name">
							</v-select>
							<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.stockist_edc_bank_name">{{konfirmResponse.stockist_edc_bank_name}}</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3">
							<input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nomor Rekening" v-model="params.stockist_edc_bank_account_no" @click="getNomorRek" @focus="() => konfirmResponse.edc_bank_account_no = ''">
							<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.edc_bank_account_no">{{konfirmResponse.edc_bank_account_no}}</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3">
							<input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nama Nasabah" v-model="params.stockist_edc_bank_account_name" @click="getNama" @focus="() => konfirmResponse.edc_bank_account_name = ''">
							<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.edc_bank_account_name">{{konfirmResponse.edc_bank_account_name}}</div>
						</div>
					</div>
					<div class="col-12 text-center pt-4 pb-3 pl-0 pr-0">
						<button class="col-6 col-md-4 pt-2 pb-2 btn btn-blue" @click="simpan">
							<div class="font-size-11 text-uppercase">simpan</div>
						</button>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal"></div>
			</template>
		</i-modal>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-6 col-md-5">
							<img class="img-fluid" src="/assets/modal/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 mt-auto mb-auto pt-3 pt-md-0 text-center text-md-left">
							<div class="font-size-11 font-weight-bold">Konfirmasi Hapus</div>
							<div class="font-size-10 pt-1 pt-md-3">Apakah Anda yakin ingin menghapus Data ini?</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-md-end">
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalAlert">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button @click="hapus()" class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Yakin</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import IModal from '@/components/IModal.vue';
import { mapState, mapActions } from 'vuex';

export default {
	components: {
		IModal,
	},
	data() {
		return {
			action : '',
			params: {
				stockist_edc_no : '',
				stockist_edc_name : '',
				stockist_edc_bank_name : '',
				stockist_edc_bank_account_no : '',
				stockist_edc_bank_account_name : ''
			},
			delete : {
				stockist_edc_id : ''
			}
		}
	},
	methods: {
		...mapActions('edcList', ['getEdc', 'addPembayaranEdc', 'getBank', 'updatePembayaranEdc', 'deletePengaturanEdc']),
		getNomorEdc() {
			this.konfirmResponse.edc_no = ''
		},
		getNamaEdc() {
			this.konfirmResponse.edc_name = ''
		},
		getBankName() {
			this.konfirmResponse.stockist_edc_bank_name = ''
		},
		getNomorRek() {
			this.konfirmResponse.edc_bank_account_no = ''
		},
		getNama() {
			this.konfirmResponse.edc_bank_account_name = ''
		},
		addAdmin(val) {
			this.action = val
			this.$refs.modalAddAdmin.modalShow()
		},
		hideAddAdmin() {
			this.$refs.modalAddAdmin.modalHide()
			this.konfirmResponse.edc_no = ''
			this.konfirmResponse.edc_name = ''
			this.konfirmResponse.stockist_edc_bank_name = ''
			this.konfirmResponse.edc_bank_account_no = ''
			this.konfirmResponse.edc_bank_account_name = ''
			this.action = ''
			this.clearData()
		},
		delAdmin(val) {
			this.delete.stockist_edc_id = val
			this.$refs.modalAlert.modalShow()
		},
		hideModalAlert() {
			this.$refs.modalAlert.modalHide()
			this.delete.stockist_edc_id = ''
		},
		editEDC(val) {
			if(val.stockist_edc_is_active == 0) {
				val.stockist_edc_is_active = 1
			} else if(val.stockist_edc_is_active) {
				val.stockist_edc_is_active = 0
			}
			this.updatePembayaranEdc(val)
		},
		hapus() {
			this.deletePengaturanEdc(this.delete).then( () => {
				this.getEdc()
				if(this.responSukses == 200) {
					this.$refs.modalAlert.modalHide()
					this.clearData()
				} else {
					this.$refs.modalAlert.modalShow()
				}
			})
		},
		edit(val, note) {
			this.action = note
			this.params.stockist_edc_no = val.stockist_edc_no
			this.params.stockist_edc_name = val.stockist_edc_name
			this.params.stockist_edc_bank_name = val.stockist_edc_bank_name
			this.params.stockist_edc_bank_account_no = val.stockist_edc_bank_account_no
			this.params.stockist_edc_bank_account_name = val.stockist_edc_bank_account_name
			this.params.stockist_edc_id = val.stockist_edc_id
			this.params.stockist_edc_is_active = val.stockist_edc_is_active
			this.$refs.modalAddAdmin.modalShow()
		},
		simpan () {
			if(this.action == 'add') {
				this.addPembayaranEdc(this.params).then( () => {
					this.getEdc()
					if(this.responSukses == 200) {
						this.$refs.modalAddAdmin.modalHide()
						this.clearData()
					} else {
						this.$refs.modalAddAdmin.modalShow()
					}
				})
			} else {
				this.updatePembayaranEdc(this.params).then( () => {
					this.getEdc()
					if(this.responSukses == 200) {
						this.$refs.modalAddAdmin.modalHide()
						this.clearData()
					} else {
						this.$refs.modalAddAdmin.modalShow()
					}
				})
			}
		},
		clearData() {
			this.params.stockist_edc_no = ''
			this.params.stockist_edc_name = ''
			this.params.stockist_edc_bank_name = ''
			this.params.stockist_edc_bank_account_no = ''
			this.params.stockist_edc_bank_account_name = ''
			this.params.stockist_edc_id = ''
			this.params.stockist_edc_is_active = ''
			this.action = ''
		}
	},
	computed: {
		...mapState('edcList', ['edc', 'konfirmResponse', 'bank', 'responSukses']),
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Setting EDC');
		this.getBank()
		this.getEdc()
	}
};
</script>
